import { IconFreeAssembly } from '@gazin/ecommerce-ui'
import {
  BadgeMontagemGratisContainer,
  BadgeMontagemGratisMensagem,
} from './styles'

export const BadgeMontagemGratis = () => {
  return (
    <BadgeMontagemGratisContainer>
      <IconFreeAssembly width="1.3rem" height="1.5rem" />
      <BadgeMontagemGratisMensagem>
        Montagem <span className="texto-destacado">gratuita</span> disponível
      </BadgeMontagemGratisMensagem>
    </BadgeMontagemGratisContainer>
  )
}
